var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"c-Badge",class:_vm.badgeClassObject},[_vm._v(_vm._s(_vm.finalValue))])}
var staticRenderFns = []

export { render, staticRenderFns }